import { types, Instance } from "mobx-state-tree";

export const UserModel = types.model({
  id: types.identifier,
  created_at: types.maybeNull(types.string),
  deleted_at: types.maybeNull(types.string),
  additional_emails: types.maybeNull(types.array(types.string)),
  additional_phones: types.maybeNull(types.array(types.string)),
  email: types.string,
  firstname: types.string,
  lastname: types.string,
  phone: types.number,
  update_at: types.maybeNull(types.string),
  profiles: types.array(types.model({ id: types.identifier, type: types.string })),
  source: types.maybeNull(types.string),
  permissions: types.maybeNull(types.array(types.model({ id: types.identifier, type: types.string }))),
});

export interface User extends Instance<typeof UserModel> {}
